<template>
  <Transition
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    enter-active-class="transition-opacity duration-125"
    leave-active-class="transition-opacity duration-125"
    mode="out-in"
  >
    <slot />
  </Transition>
</template>
